import { toNumber, normalizeSelectInput } from "../../../../helpers";
import ibsStore from "../../../Stores/IbsSurveyStore"
import { mapToDropdownOption, convertMandateRegionToID, mandateRegionOptions, convertMandateSubstyleToID, mandateSubstyleOptions, mapIDToName } from "../../../../ibsHelper";
import { SelectCombosIBS, NumberFormat } from "../../../../Enums/constants";
import { saveValueNew, updateMandateInfoSingleCtrl } from "../../../../control";
import { isNumField } from "../../../../Helpers/TableHelper";
import { columnCalculation } from "../../../../Helpers/TableCalculationHelper";
import sharedStore from "../../../Stores/SharedStore";
import { toJS } from "mobx";
import SurveyStore from "../../../Stores/SurveyStore";
import { formatNumber } from "../../../../Helpers/General/FormatHelper";

export function handleHOTChangeDealTerms(table, rowNum, qId, oldValue, newValue, props, referenceToTable) {
    if (rowNum !== undefined && rowNum !== null
        && qId !== undefined && qId !== null
        && newValue != oldValue
        && newValue !== 'undefined') { // TODO something weird happens when this is changed to newValue !== oldValue

        let normalizedNewValue = newValue;

        if (isNumField(table, qId, props)) {
            normalizedNewValue = toNumber(newValue);
            if (Number.isNaN(normalizedNewValue)) {
                // It's a number field, but newValue is not a number
                // just save an empty value
                normalizedNewValue = null;
            }
        }
      
        let mandateID, rowID, result;
        let mandateFound = ibsStore.allTableResponses[props.tableName].find(item => item.rowID === referenceToTable[rowNum].rowID)
        mandateID = mandateFound.mandateID
        rowID = referenceToTable[rowNum].rowID //the rowId

        if (qId === "isInCommitPeriod") {
            normalizedNewValue = normalizeSelectInput(newValue, SelectCombosIBS.YES_NO)
        }
        if (qId === "mandateRegionID") { //lmtd partnerships
            normalizedNewValue = convertMandateRegionToID(qId, newValue)

        }
        else if (qId === "isCostPerfPay") {
            normalizedNewValue = normalizeSelectInput(newValue, SelectCombosIBS.YES_NO)
        }
        else if (["subStyleID1", "subStyleID2", "subStyleID3"].includes(qId)) {
            normalizedNewValue = convertMandateSubstyleToID(qId, newValue)

        }
       
        if (["originalCommitmentMil", "unreturnedInvestmentCapMil", "feePercentCommitment", "feePercentInvestedCap", "otherBaseFeeBasisMil", "feePercentOther", "carriedInterestPercent", "hurdleRatePercent", "rebatePercent", "otherBaseFeebasisDescPriv"].includes(qId)) {
            let rulesSet = saveValueNew(qId, normalizedNewValue, { tableName: props.tableName, rowId: rowID })

        } else {
            updateMandateInfoSingleCtrl(qId, normalizedNewValue, mandateID)

        }
        //find corresponding mandate and save it there
        let originalMandate = ibsStore.mandateData.find(item => item.rowID === referenceToTable[rowNum].rowID)
        if (originalMandate) originalMandate[qId] = normalizedNewValue
    }
}

export function renderPrivateEquityTotalRow(props) {
    let totalRow = {};
    totalRow['OriginalCommitmentMil'] = formatNumber(NumberFormat.MONEYMILLION, columnCalculation("OriginalCommitmentMil", true, props));
    totalRow['UnreturnedInvestmentCapMil'] = formatNumber(NumberFormat.MONEYMILLION, columnCalculation("UnreturnedInvestmentCapMil", true, props));
    totalRow['NetAssetValueMil'] = formatNumber(NumberFormat.MONEYMILLION, columnCalculation("NetAssetValueMil", true, props));
    return totalRow;
}

export function handleLtdPartnershipData(props, referenceToTable, listOfHeaderRows, dataObj) {

}

export function PublicDealTermsCellRenderer(instance, td, row, col, prop, value, cellProperties, referenceToTable) {
    if (prop == "fundName") { //Ltd Partnerships
        cellProperties.readOnly = true
        td.className = td.className + " readOnlyCell"
    } else if (prop == "holdingNavAvg") {
        cellProperties.readOnly = true
        td.className = td.className + " readOnlyCell"
    } 

    if (prop == "costPerfFeebasisDesc") {
        if (referenceToTable[row]["isCostPerfPay"] != "Yes") {
            cellProperties.readOnly = true
            td.className = td.className + " readOnlyCell"
        } else {
            cellProperties.readOnly = false

        }
      
    }
    return cellProperties;

}
export function PrivateDealTermsCellRenderer(instance, td, row, col, prop, value, cellProperties, referenceToTable) {
    if (prop == "fundName") { //Ltd Partnerships
        cellProperties.readOnly = true
        td.className = td.className + " readOnlyCell"
    } else if (prop == "holdingNavAvg") {
        cellProperties.readOnly = true
        td.className = td.className + " readOnlyCell"
    }

    return cellProperties;

}
export function beforeKeyDownPrivateEquity(e, editor) {
    try {
        // Prevent people from entering invalid dates in DataYear
        if (editor.prop === "DataYear" &&
            ((!/[0-9]/.test(e.key) || editor.TEXTAREA.value.length >= 4)
                && e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'Backspace')) {
            e.preventDefault()
        }
    }
    catch { }
}

export function DealTermCells(cellProps, row, col, prop, props, referenceToTable, listOfHeaderRows) {
    var cellProperties = cellProps;
    if (["subStyleID1", "subStyleID2", "subStyleID3"].includes(prop)) {
     
        let mandateSubstylesForRow 
        //filter by category id
        let mandateRowFound = ibsStore.allTableResponses[props.tableName].find(item => item.rowID == referenceToTable[row]?.rowID);
      
        let exists = sharedStore.mandateSubstyles.some(function (item) {
            return mandateRowFound?.assetClassID === item?.assetClassID;
        });
        
        //if exists then filter by it, else use category
        if (exists) {
            mandateSubstylesForRow = sharedStore.mandateSubstyles.filter(function (value) {
                return mandateRowFound.assetClassID == value.assetClassID;
            });
        } else {
            mandateSubstylesForRow = sharedStore.mandateSubstyles.filter(function (value) {
                return mandateRowFound?.assetClassCategoryID == value?.assetClassCategoryID;
            });
        }

        let filteredList = mandateSubstyleOptions(mandateSubstylesForRow)
        let removeList
        if (prop =="subStyleID1") {
            removeList = [referenceToTable[row]?.subStyleID2, referenceToTable[row]?.subStyleID3]

        } else if (prop == "subStyleID2") {
            removeList = [referenceToTable[row]?.subStyleID1,  referenceToTable[row]?.subStyleID3]

        } else if (prop == "subStyleID3") {
            removeList = [referenceToTable[row]?.subStyleID1, referenceToTable[row]?.subStyleID2, ]

        }
        const filteredListFinal = filteredList.filter(item => !removeList.includes(item));
        cellProperties.source = filteredListFinal
    } 

    return cellProperties;
}

export function createPublicTerms(props, referenceToTable, listOfHeaderRows, dataObj) {
    //hope this only will not get retriggered when we update the overriden stuff
    //  Need to overwrite this to keep things correct
    let rowCount = -1;
    if (!ibsStore.allTableResponses[props.tableName]) return {}
    //compile list of errors

    let renderTotalRow = props.includeTotalRow;
    
    var rawData = ibsStore.allTableResponses[props.tableName]
    if (rawData == [] || typeof rawData === "undefined" || rawData === undefined) return {};
    for (const datum of rawData) {
        let child = {}
        if (!SurveyStore.questionMode) {
            child =
            {
                fundName: datum.managerName + " - " + datum.fundName,
                holdingNavAvg: datum.holdingNavAvg,
                mandateRegionID: mapIDToName(sharedStore.mandateRegions, datum.mandateRegionID, "mandateRegionID", "regionName"),
                subStyleID1: mapIDToName(sharedStore.mandateSubstyles, datum.subStyleID1, "subStyleID", "subStyleName"),
                subStyleID2: mapIDToName(sharedStore.mandateSubstyles, datum.subStyleID2, "subStyleID", "subStyleName"),
                subStyleID3: mapIDToName(sharedStore.mandateSubstyles, datum.subStyleID3, "subStyleID", "subStyleName"),
                costMgrBasePctTier1: datum.costMgrBasePctTier1,
                holdingNavTier1: datum.holdingNavTier1,
                costMgrBasePctTier2: datum.costMgrBasePctTier2,
                holdingNavTier2: datum.holdingNavTier2,
                costMgrBasePctTier3: datum.costMgrBasePctTier3,
                holdingNavTier3: datum.holdingNavTier3,
                costMgrBasePctTier4: datum.costMgrBasePctTier4,
                holdingNavTier4: datum.holdingNavTier4,
                costMgrBasePctTier5: datum.costMgrBasePctTier5,
                holdingNavTier5: datum.holdingNavTier5,
                otherBaseFeebasisDescPubl: datum.otherBaseFeebasisDescPubl,
                isCostPerfPay: mapToDropdownOption(datum.isCostPerfPay, SelectCombosIBS.YES_NO),
                costPerfFeebasisDesc: datum.costPerfFeebasisDesc, 
                rowID: datum.rowID
            }
        }
        
        dataObj.push(child)
        rowCount = rowCount + 1
        referenceToTable.push(child)
    }

    let totalRow = {};
    totalRow["fundName"] = "Total";
    totalRow['holdingNavAvg'] = formatNumber(NumberFormat.MONEYMILLION, columnCalculation("holdingNavAvg", true, props));
    totalRow['mandateRegionID'] = "";
    totalRow['subStyleID1'] = "";
    totalRow['subStyleID2'] = "";
    totalRow['subStyleID3'] = "";
    totalRow['costMgrBasePctTier1'] = "";
    totalRow['originalCommitmentMil'] = "";
    totalRow['holdingNavTier1'] = "";
    totalRow['costMgrBasePctTier2'] = "";
    totalRow['holdingNavTier2'] = "";
    totalRow['costMgrBasePctTier3'] = "";
    totalRow['holdingNavTier3'] = "";
    totalRow['costMgrBasePctTier4'] = "";
    totalRow['holdingNavTier4'] = "";
    totalRow['costMgrBasePctTier5'] = "";
    totalRow['holdingNavTier5'] = "";
    totalRow['otherBaseFeebasisDescPubl'] = "";
    totalRow['isCostPerfPay'] = "";
    totalRow['costPerfFeebasisDesc'] = "";
    totalRow['rowID'] = "";

    if(renderTotalRow === true) {
        dataObj.push(totalRow);
        listOfHeaderRows.push(dataObj.length - 1);
    }
    return [dataObj, listOfHeaderRows, referenceToTable];
}

export function handlePublicTerms(props, referenceToTable, listOfHeaderRows, dataObj) {
    let obj = createPublicTerms(props, referenceToTable, listOfHeaderRows, dataObj)

    let data = obj[0]
    let headers = obj[1]
    referenceToTable = obj[2]

    return [data, referenceToTable, headers]
}


export function createPrivateTerms(props, referenceToTable, listOfHeaderRows, dataObj) {
    //hope this only will not get retriggered when we update the overriden stuff
    //  Need to overwrite this to keep things correct
    let rowCount = -1;
    if (!ibsStore.allTableResponses[props.tableName]) return {}
    //compile list of errors

    let renderTotalRow = props.includeTotalRow;
   
    var rawData = ibsStore.allTableResponses[props.tableName]
    if (rawData == [] || typeof rawData === "undefined" || rawData === undefined) return {};
    for (const datum of rawData) {
        let child = {}
        if (!SurveyStore.questionMode) {
            child =
            {
                fundName: datum.managerName + " - " + datum.fundName,
                holdingNavAvg: datum.holdingNavAvg,
                mandateRegionID: mapIDToName(sharedStore.mandateRegions, datum.mandateRegionID, "mandateRegionID", "regionName"),
                subStyleID1: mapIDToName(sharedStore.mandateSubstyles, datum.subStyleID1, "subStyleID", "subStyleName"),
                subStyleID2: mapIDToName(sharedStore.mandateSubstyles, datum.subStyleID2, "subStyleID", "subStyleName"),
                subStyleID3: mapIDToName(sharedStore.mandateSubstyles, datum.subStyleID3, "subStyleID", "subStyleName"),
                vintageYear: datum.vintageYear,
                originalCommitmentMil: datum.originalCommitmentMil,
                isInCommitPeriod: mapToDropdownOption(datum.isInCommitPeriod, SelectCombosIBS.YES_NO),
                unreturnedInvestmentCapMil: datum.unreturnedInvestmentCapMil,
                commitmentEndYear: datum.commitmentEndYear,
                feePercentCommitment: datum.feePercentCommitment,
                feePercentInvestedCap: datum.feePercentInvestedCap,
                otherBaseFeebasisDescPriv: datum.otherBaseFeebasisDescPriv,
                otherBaseFeeBasisMil: datum.otherBaseFeeBasisMil,
                feePercentOther: datum.feePercentOther,
                carriedInterestPercent: datum.carriedInterestPercent,
                hurdleRatePercent: datum.hurdleRatePercent,
                rebatePercent: datum.rebatePercent,
                rowID: datum.rowID
            }
        }
        dataObj.push(child)
        rowCount = rowCount + 1
        referenceToTable.push(child)
    }
    let totalRow = {};
    totalRow['fundName'] = "Total";
    totalRow['holdingNavAvg'] = formatNumber(NumberFormat.MONEYMILLION, columnCalculation("holdingNavAvg", true, props));
    totalRow['mandateRegionID'] = "";
    totalRow['subStyleID1'] = "";
    totalRow['subStyleID2'] = "";
    totalRow['subStyleID3'] = "";
    totalRow['vintageYear'] = "";
    totalRow['originalCommitmentMil'] = formatNumber(NumberFormat.MONEYMILLION, columnCalculation("originalCommitmentMil", true, props));

    if(renderTotalRow) {
        dataObj.push(totalRow);
        listOfHeaderRows.push(dataObj.length - 1);
    }
    return [dataObj, listOfHeaderRows, referenceToTable];
}

export function handlePrivateTerms(props, referenceToTable, listOfHeaderRows, dataObj) {
    let obj = createPrivateTerms(props, referenceToTable, listOfHeaderRows, dataObj)

    let data = obj[0]
    let headers = obj[1]
    referenceToTable = obj[2]

    return [data, referenceToTable, headers]
}